var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.69V14.94C16.5009 15.1489 16.4581 15.3556 16.3744 15.547C16.2907 15.7384 16.168 15.9102 16.0141 16.0514C15.8601 16.1926 15.6784 16.3001 15.4806 16.367C15.2827 16.434 15.073 16.4588 14.865 16.44C12.5571 16.1892 10.3403 15.4006 8.3925 14.1375C6.58037 12.986 5.04401 11.4496 3.8925 9.63751C2.62499 7.68092 1.83619 5.45326 1.59 3.13501C1.57126 2.92761 1.59591 2.71858 1.66238 2.52123C1.72885 2.32388 1.83568 2.14253 1.97608 1.98873C2.11647 1.83493 2.28736 1.71204 2.47785 1.6279C2.66834 1.54376 2.87426 1.50021 3.0825 1.50001H5.3325C5.69648 1.49643 6.04935 1.62532 6.32532 1.86266C6.6013 2.1 6.78156 2.4296 6.8325 2.79001C6.92747 3.51006 7.10359 4.21706 7.3575 4.89751C7.45841 5.16595 7.48025 5.4577 7.42043 5.73817C7.36062 6.01865 7.22165 6.27609 7.02 6.48001L6.0675 7.43251C7.13517 9.31017 8.68984 10.8648 10.5675 11.9325L11.52 10.98C11.7239 10.7784 11.9814 10.6394 12.2618 10.5796C12.5423 10.5198 12.8341 10.5416 13.1025 10.6425C13.783 10.8964 14.49 11.0725 15.21 11.1675C15.5743 11.2189 15.9071 11.4024 16.1449 11.6831C16.3828 11.9638 16.5091 12.3222 16.5 12.69Z",
    stroke: "#141414",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c1aef5050710607c8d9047323479857f.svg";
export { ForwardRef as ReactComponent };